import React, { useState, useRef, useEffect, useContext, useCallback } from "react";

import { Box, Container, Grid, Typography, Stack, Button, CircularProgress } from '@mui/material';

import CmsContext from '../../../store/cms-context';

import { getAccessJwtToken } from '../../../store/globalUtilities';

import ProductsColorsDialog from "./SubComponents/ProductsColorsDialog";

import ProductsColorsListTable from "./SubComponents/ProductsColorsListTable";

import { default_products_colors_dialog } from "../../../Utilities/Metrics";

import cloneDeep from 'lodash/cloneDeep';

import { has_admin_access, has_product_management_write_access } from "../../../Utilities/HelperFunctions";


function ProductsColors(props) {

  console.log("Products Colors rendered")

  const cmsContext = useContext(CmsContext);

  const isMountedRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [all_products_colors, set_all_products_colors] = React.useState([]);

  const [active_accounts, set_active_accounts] = React.useState([]);

  const [products_colors_dialog_state, set_products_colors_dialog_state] = React.useState(cloneDeep(default_products_colors_dialog));


  useEffect(() => {

    isMountedRef.current = true

    get_all_products_colors()

    return () => isMountedRef.current = false;

  }, [])


 


  function handle_active_accounts_change(event, newValue) {

    set_active_accounts(newValue)

  }

  function show_create_product_color_dialog() {
    
    const temp_dialog_state = cloneDeep(default_products_colors_dialog);

    temp_dialog_state.is_dialog_open = true

    temp_dialog_state.type = "Create"

    set_products_colors_dialog_state(temp_dialog_state)

  }

  const delete_products_colors = useCallback(() => {
    
    console.log('delete products_colors')

    var temp_products_colors = [...all_products_colors].filter((product_color) => product_color.is_checked);

    console.log('filtered were', temp_products_colors)

    if(temp_products_colors.length === 0){
      cmsContext.setSnackBarOpen(true, "error", "Please select valid products_colors!")
      return;
    }

    temp_products_colors = temp_products_colors.map((product_color) => {

      return(product_color.name)

    })

    console.log('final products_colors were', temp_products_colors)

    const request_body = {}

    request_body.product_color = temp_products_colors

    request_body.request_type = "Delete"

    request_body.account_email = cmsContext.current_shop.email

    console.log('body was: ', request_body)
    

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds) => {

       if(!has_admin_access(auth_creds.current_user)){
        cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
        setIsLoading(false)
        return
      }

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/products/colors', {
              crossDomain:true,
              method: 'POST',
              headers: {
                'content-type':'application/json',
                'Authorization':auth_creds.jwt
              },
              body: JSON.stringify(request_body)
            })
              .then(res => res.json())
              .then(
                (result) => {
      
                  setIsLoading(false)
  
                  console.log('result was: ', result)

                  if(result.message){

                    cmsContext.setSnackBarOpen(true, "success", result.message)

                    get_all_products_colors()
                  
                  }else if(result.errorMessage){

                    cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                    
                  }else{

                    cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                    console.log('Error', result)

                  }
                  
                },
            
                (error) => {
                  setIsLoading(false)
                  cmsContext.setSnackBarOpen(true, "error", error)
                  console.log('error was',error)
                }
          );
  
      });

  }, [all_products_colors]);


  const set_dialog_product_color = useCallback((product_color, is_open) => {

      const temp_products_colors_dialog_state = cloneDeep(default_products_colors_dialog)

      temp_products_colors_dialog_state.product_color = product_color

      temp_products_colors_dialog_state.is_dialog_open = is_open

      temp_products_colors_dialog_state.type = "Update"
      
      console.log("update state was: ", temp_products_colors_dialog_state)

      set_products_colors_dialog_state(temp_products_colors_dialog_state)

  },[])

  const set_dialog_loading = useCallback(( is_loading) => {

    const temp_products_colors_dialog_state = {...products_colors_dialog_state}

    temp_products_colors_dialog_state.isLoading = is_loading

    console.log('dialog state was: ', temp_products_colors_dialog_state)

    set_products_colors_dialog_state(temp_products_colors_dialog_state)

  },[products_colors_dialog_state])


  const reset_dialog_state = useCallback((is_loading) => {

    set_products_colors_dialog_state(cloneDeep(default_products_colors_dialog))

  },[])





  const post_product_color = useCallback((product_color, request_type) => {


    console.log('updating')

    var request_body = {}

    request_body.product_color = product_color

    request_body.request_type = request_type

    request_body.account_email = cmsContext.current_shop.email

    console.log('body was: ', request_body)

    set_dialog_loading(true)

    getAccessJwtToken().then((auth_creds) => {

      if(!has_product_management_write_access(auth_creds.current_user)){
        cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
        setIsLoading(false)
        return
      }


      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/products/colors', {
          crossDomain:true,
          method: 'POST',
          headers: {
            'content-type':'application/json',
            'Authorization':auth_creds.jwt
          },
          body: JSON.stringify(request_body)
        })
          .then(res => res.json())
          .then(
            (result) => {
    
              console.log('result was',result)

              if(result.message){

                cmsContext.setSnackBarOpen(true, "success", result.message)
                reset_dialog_state()

                get_all_products_colors()
              
              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                set_dialog_loading(false)
                
              }else{

                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)
                set_dialog_loading(false)

              }
  
            },
        
            (error) => {
              set_dialog_loading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
              console.log('error was',error)
            }
      )

    })



  },[reset_dialog_state, set_dialog_loading, cmsContext]);







  return(

    <>

   {isLoading ? <CircularProgress style={{position: 'absolute', top: '50%', left: '50%', MozTransform: 'translateX(-50%) translateY(-50%)', WebkitTransform: 'translateX(-50%) translateY(-50%)', transform: 'translateX(-50%) translateY(-50%)'}} /> :
   
   <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 8,
    }}
  >


    <Container maxWidth={false} style={{maxWidth:"1000px",overflow:'visible'}}>
  
    <Grid
        container
        spacing={2}
        style={{overflow:'visible'}}
      >

        <Grid
          item
          xs={12}
        >

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          spacing={2}
        >

          <Typography variant="h5">Products Colors</Typography>

          <div>

          <Button variant="contained" onClick = {() => {show_create_product_color_dialog()}}>Create Color</Button>

          </div>

        </Stack>

      </Grid>

      <Grid
          item
          xs={12}
        >


         {products_colors_dialog_state ? <ProductsColorsListTable delete_products_colors={delete_products_colors} set_dialog_product_color={set_dialog_product_color} all_products_colors={all_products_colors} set_all_products_colors={set_all_products_colors}>

          </ProductsColorsListTable>  : null}


      </Grid>


      </Grid>

    </Container>      


    </Box>

     }

     <ProductsColorsDialog post_product_color={post_product_color} products_colors_dialog_state={products_colors_dialog_state} set_products_colors_dialog_state={set_products_colors_dialog_state}></ProductsColorsDialog>

    </> 


  );


  function get_all_products_colors() {
    
    console.log('store_access_token')


    // user api

    // error handling and state managment required

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds) => {

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/products/colors', {
          crossDomain:true,
          method: 'GET',
          headers: {
            'Authorization':auth_creds.jwt
          }})
          .then(res => res.json())
          .then(
            (result) => {
              
              setIsLoading(false)
  
              console.log('result was',result)

              if(result.data){


                if(result.data.length === 0){

                  cmsContext.setSnackBarOpen(true, "info", "No colors yet. Let's create one to get started.")

                  set_all_products_colors([])

                  return

                }


                const all_products_colors = []

                var temp_product_color;

                result.data.forEach((product_color) =>{

                    temp_product_color = cloneDeep(product_color)
                    temp_product_color.is_checked = false
                    all_products_colors.push(temp_product_color)

                })

                console.log('all options')

              
                set_all_products_colors(all_products_colors)

              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                
              } else{
                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)
              }

              
  
            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('error was',error)
            }
           
      )

    })


  }


};


export default ProductsColors;